import { RouteConfig } from 'vue-router';

const { modules: { landing } } = require('../../../whitelabel.config');

export default <RouteConfig[]> [
  {
    path: '/',
    redirect: landing ? '/landing' : '/login',
  },
  {
    path: '/landing',
    component: (): Promise<object> => import(/* webpackChunkName: "landing" */ '@/modules/landing/components/Landing.vue'),
  },
];
